// src/utils/purchaseEntry.js
import moment from "moment";
import dayjs from "dayjs";
import Big from "big.js";
import {
  formatToCompanyTimezone,
  formatToUtc,
  getDateTimeFromSelectedDate,
  getYearFromCompanyDate,
} from "../lib/functions";

export const createPurchaseEntryPayload = (state, authInfo) => {
  const {
    itemCart,
    payPurchaseCart,
    selectedDiscountAcc,
    selectedTaxAcc,
    selectedTransportAcc,
    supplierInfo,
    footerValues,
    conversion_rate,
    conversion_currency,
    entryDate,
    invoiceDate,
    tag_field_id,
    dueDate,
    voucherNumber,
    pur_invoice_no,
    purchase_id,
    selectedPurchaseAcc,
    selectedAssetAcc,
    conversionRate,
    isTatmeen,
  } = state;
  console.log('state.footerValues.other_service_cost', state.footerValues.other_service_cost, state.footerValues.payServiceCart)

  const isGstDisabled =
    authInfo?.gst_enabled === "yes" &&
    supplierInfo.gst_type === "unregistered";

  console.log(authInfo, "check11");
  console.log(supplierInfo.gst_type, "check1122");

  // convert selected/entry Date to utc date + time
  let finalEntryDate = entryDate;
  if (!dayjs(entryDate).isSame(dayjs(), "day")) {
    finalEntryDate = getDateTimeFromSelectedDate(entryDate); // Merge date + current time in TZ
  } else {
    finalEntryDate = entryDate; // Use now in TZ
  }

  let dateUTC = formatToUtc(finalEntryDate);
  let companydate = formatToCompanyTimezone(dateUTC);
  const vchYear = getYearFromCompanyDate(companydate);

  let finalInvoiceDate = invoiceDate;
  if (!dayjs(invoiceDate).isSame(dayjs(), "day")) {
    finalInvoiceDate = getDateTimeFromSelectedDate(invoiceDate); // Merge date + current time in TZ
  } else {
    finalInvoiceDate = invoiceDate; // Use now in TZ
  }

  // Discount for a single item row: reads whichever mode is active
  // (percent, the default/undefined-safe mode, or a flat amount), clamped
  // so a flat amount can never exceed the item's own line total.
  const getItemDiscountAmount = (item, line) => {
    if (item.discountMode === "amount") {
      const raw = new Big(item.discountAmt || 0);
      return raw.gt(line) ? line : raw.lt(0) ? new Big(0) : raw;
    }
    const discountPer = new Big(item.discount || 0);
    return line.times(discountPer).div(100);
  };

  let totalTax = itemCart.reduce((sum, item) => {
    if (item?.bonus) return sum;
    const qty = new Big(item.quantity || 0);
    const rate = new Big(item.rate || 0);
    const taxPer = isGstDisabled
      ? new Big(0)
      : new Big(item.tax_per || 0);

    let line = qty.times(rate);

    const discountAmount = getItemDiscountAmount(item, line);
    const afterDiscount = line.minus(discountAmount);

    const vatAmount = afterDiscount.times(taxPer).div(100);

    return sum.plus(vatAmount);
  }, new Big(0));

  const {
    subtotal,
    total_discount,
    // totalTax,
    grandTotal,
    paidAmount,
    dueAmount,
    description,
    discountPct,
    taxPct,
  } = footerValues;

  return {
    pur_id: purchase_id || 0,
    orderId: 0,
    vchdate: vchYear,

    itemCart: itemCart.map((it) => ({
      warehouse_id: it.warehouse_id || 0,
      warehouse_name: it.warehouse_name || "",
      item_id: it.item_id,
      item_name: it.product || "",
      item_qty: it.quantity,
      pur_qty: it.quantity,
      item_rate: it.bonus ? 0 : it.rate,
      pur_rate: it.bonus ? 0 : it.rate,

      discount_acc_id: selectedDiscountAcc?.acc_id || 0,
      discount_acc_name: selectedDiscountAcc?.acc_name || "",
      tax_acc_id: selectedTaxAcc?.acc_id || 0,
      tax_acc_name: selectedTaxAcc?.acc_name || "",

      // ✅ match old UI: numeric values, not strings
      item_discount: it.bonus
        ? 0
        : Number(
          getItemDiscountAmount(
            it,
            new Big(it.quantity || 0).times(it.rate || 0)
          ).toFixed(13)
        ),

      // Kept meaningful even in amount mode (back-computed from the flat
      // amount) — the printed voucher's "individual" calc-mode template
      // reads this field directly, not the discount amount.
      item_discount_per: it.bonus
        ? 0
        : Number(
          (() => {
            const line = new Big(it.quantity || 0).times(it.rate || 0);
            if (it.discountMode !== "amount") return it.discount || 0;
            if (line.eq(0)) return 0;
            return getItemDiscountAmount(it, line)
              .div(line)
              .times(100)
              .toFixed(13);
          })()
        ),

      discount_mode: it.discountMode === "amount" ? "amount" : "percent",

      item_tax: isGstDisabled
        ? 0
        : it.bonus
          ? 0
          : Number(
            (() => {
              const line = new Big(it.quantity || 0).times(it.rate || 0);
              return line
                .minus(getItemDiscountAmount(it, line))
                .times(it.tax_per || 0)
                .div(100)
                .toFixed(13);
            })()
          ),

      item_tax_per: isGstDisabled
        ? "0"
        : it.bonus
          ? "0"
          : String(it.tax_per || 0),

      // item_total: ((Number(it.line_total) || 0)) ,

      item_total: (() => {
        if (it.bonus) return 0;
        const qty = new Big(it.quantity || 0);
        const rate = new Big(it.rate || 0);
        const taxPer = isGstDisabled
          ? new Big(0)
          : new Big(it.tax_per || 0);
        let line = qty.times(rate);

        const discountAmt = getItemDiscountAmount(it, line);
        const afterDiscount = line.minus(discountAmt);
        const taxAmt = afterDiscount.times(taxPer).div(100);
        const finalLine = state.taxMode === "individual"
          ? afterDiscount.plus(taxAmt)
          : line;
        const convertedLine = conversionRate
          ? finalLine.times(conversionRate)
          : finalLine;
        return Number(convertedLine.toFixed(13));
      })(),

      bonus: it.bonus ? 1 : 0,
      bounus_update_check: false,

      // ✅ batch fields
      batch_name_id: it.batch_id,
      serial_mode: it.serial_mode || "unit",
      batch_name: it.batch_name || "",
      batch_expiry: it.batch_expiry || null,
      is_expiry_disable: it.is_expiry_disable || false,

      serials: it.serials || [],
      child_sscc_code: it.child_sscc_code || null,
      unit_id: it.unit_id || 0,
      unit_name: it.unit_name || "",
      unit_symbol: it.unit_symbol || "",
      per_unit_id: it.unit_id || 0,
      per_unit_symbol: it.unit_symbol || "",
      per_conversion: it.per_conversion || 1,
      base_unit_name: it.base_unit_name || null,
      conversion: it.conversion || 1,
      units: it.units || [],
      is_tatmeen_required:it.is_tatmeen_required,

      // ✅ old UI extras
      display_text: `${it.product || ""}${it.item_id ? " - PO" + it.item_id : ""
        }`,
      qty_display: it.quantity ? `${it.quantity} ${it.unit_symbol || ""}` : "",
      retail_qty: 0,
      gtn_num: it.gtn_num || "",
    })),

    payCart: payPurchaseCart.map((p) => ({
      from_acc_id: p?.from_acc_id || 0,
      from_acc_name: p?.from_acc_name || "",
      acc_type_id: p?.acc_type_id,
      tran_amount: parseFloat(p?.tran_amount || 0).toFixed(2),
      date:
        p?.from_acc_name === "CDC"
          ? moment().format("YYYY-MM-DD") // only for CDC
          : p?.date || null,
      cheque_number: p?.cheque_number || null,
      expected_bank_acc_id: p?.expected_bank_acc_id || null,
    })),

    // payServiceCart: footerValues.payServiceCart,
    payServiceCart: Array.isArray(footerValues?.payServiceCart)
      ? footerValues.payServiceCart
      : [],

    supplier: {
      acc_id: supplierInfo?.acc_id,
      acc_name: supplierInfo?.acc_name,
      institution_name: supplierInfo?.institution_name,
      contact_no: supplierInfo?.contact_no,
      address: supplierInfo?.address,
    },

    masterData: {
      pur_voucher_no: voucherNumber,
      purchase_acc_id: selectedPurchaseAcc?.acc_id || 0,
      asset_acc_id: selectedAssetAcc?.acc_id || null,
      pur_id: purchase_id || 0,
      pur_invoice_no: pur_invoice_no || "",
      is_serial: "no",
      is_cal_type: state.taxMode === "individual" ? "individual" : "on_total",
      is_apply_discount_to_avg_Price: "no", // ✅ old UI always sends this
      entry_date: formatToUtc(finalEntryDate),
      created_date: formatToUtc(finalInvoiceDate), // ✅ old UI also sends this
      ...(dueDate ? { due_date: formatToUtc(dueDate) } : {}),
      is_tatmeen: isTatmeen ? 1 : 0,
      narration: description || "",
      sub_total: Number(new Big(subtotal || 0).toFixed(13)),
      total_discount_per: discountPct || 0,
      total_discount: Number(new Big(total_discount || 0).toFixed(13)),
      total_discount_mode: footerValues?.discountMode === "amount" ? "amount" : "percent",
      total_tax_per: isGstDisabled ? 0 : taxPct || 0,
      // total_tax: parseFloat(Number(totalTax).toFixed(2)),
      total_tax: isGstDisabled ? 0 : totalTax.toNumber(),
      total_transport_cost: 0,
      total_amount: Number(new Big(grandTotal || 0).toFixed(13)),
      paid_amount: Number(new Big(paidAmount || 0).toFixed(13)),
      due_amount: Number(new Big(dueAmount || 0).toFixed(13)),

      discount_acc_id: selectedDiscountAcc?.acc_id || 0,
      tax_acc_id: selectedTaxAcc?.acc_id || 0,
      transport_acc_id: selectedTransportAcc?.acc_id || 0,
      other_service_cost: Array.isArray(footerValues?.payServiceCart)
        ? footerValues.payServiceCart.reduce((sum, p) => sum.plus(new Big(p.tran_amount || 0)), new Big(0))
        : 0,
      conversion_rate: conversionRate || 0,
      conversion_currency: conversion_currency || null,
      ...(state.taxMode === "individual"
        ? {
          total_discount_per: discountPct || 0,
          total_discount: total_discount,
          total_tax_per: isGstDisabled ? 0 : taxPct || 0,
          total_tax: isGstDisabled ? 0 : totalTax,
        }
        : {
          total_discount_per: discountPct || 0,
          total_discount: total_discount,
          total_tax_per: isGstDisabled ? 0 : taxPct || 0,
          total_tax: isGstDisabled ? 0 : totalTax,
        }),
      ...(tag_field_id && tag_field_id.length > 0
        ? {
          tag_field_id: tag_field_id,
        }
        : {}),
      sscc_code: state.sscc_code,
    },
  };
};
